export default function RouteFallback() {
  return (
    <section className="route-fallback" aria-hidden="true">
      <div className="container">
        <div className="page-skeleton">
          <div className="skeleton-stack">
            <div className="skeleton-block skeleton-block--eyebrow" />
            <div className="skeleton-block skeleton-block--title" />
            <div className="skeleton-block skeleton-block--text" />
            <div className="skeleton-block skeleton-block--text is-short" />
          </div>
          <div className="skeleton-block skeleton-block--media" />
          <div className="skeleton-grid">
            <div className="skeleton-block skeleton-block--card" />
            <div className="skeleton-block skeleton-block--card" />
            <div className="skeleton-block skeleton-block--card" />
          </div>
        </div>
      </div>
    </section>
  );
}
